import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * -i18n- Nom de rôle À L'AFFICHAGE seulement : ETUDIANTS -> "Students" en anglais.
 * Rôle sans traduction (ajouté plus tard) -> affiché tel qu'écrit. La valeur enregistrée ne change jamais.
 * Impur : suit le changement de langue (simple recherche dans un objet, coût négligeable).
 */
@Pipe({ name: 'roleLabel', pure: false })
export class RoleLabelPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(name: any): string {
    const raw = String(name ?? '').trim();
    if (!raw) return raw;
    const key = 'roles.' + raw.toUpperCase();
    const label = this.translate.instant(key);
    return label === key ? raw : label;
  }
}
